import {
  type FilterEditorComponentProps,
  createFilter,
} from '@spotify/confidence-core-react';

import { TypeFilterEditor } from './TypeFilterEditor';
import { TypeFilterViewer } from './TypeFilterViewer';
import { typeIdToParentQuery } from './typeFilter';

const typeFilterQuery = (value: string[]): string => {
  if (!value || value.length === 0) return '';
  return value.map(typeIdToParentQuery).join(' OR ');
};

export const createTypeFilter = ({
  excludeWorkflowIds,
}: { excludeWorkflowIds?: string[] } = {}) => {
  const editor = excludeWorkflowIds
    ? (props: FilterEditorComponentProps<string[]>) => (
        <TypeFilterEditor {...props} excludeWorkflowIds={excludeWorkflowIds} />
      )
    : TypeFilterEditor;

  return createFilter<string[]>({
    id: 'type',
    label: 'Type',
    query: typeFilterQuery,
    viewer: TypeFilterViewer,
    editor,
  });
};
